import React from "react";
import { DebounceInput } from "react-debounce-input";
import { emptyString } from "../../../constants";

export const SearchComponent = ({
  searchString,
  setSearchString,
  className = emptyString,
  containerClass = "mx-4 mb-2 w20",
}) => {
  return (
    <div className={`search-container ${containerClass}`}>
      <DebounceInput
        debounceTimeout={1000}
        type="text"
        className={`search-restaurants ${className}`}
        placeholder="Search"
        value={searchString}
        onChange={(e) => setSearchString(e.target.value)}
      />
      <i className="fa fa-search search-icon" aria-hidden="true" />
    </div>
  );
};
